import { useCallback, useEffect } from "react";
import * as api from "../../../../api/servicesTypes";
import { useParams } from "react-router-dom";
import useData, { SortOrders } from "@cervello/use-data";
import { ServicesType } from "../../../../definitions/types/servicesTypes";
import { FilterOperator } from '../../../../../../../shared/types';


const usePrintServiceType = () => {
    const { projectId, serviceTypeId } = useParams<{ projectId: string, serviceTypeId: string }>();

    const getServicesTypes = useCallback(
        ({ query }) => {
            const options: { limit?: number; page?: number } = {};
            if (options.limit) {
                options.limit = Number(options.limit);
            }
            if (options.page) {
                options.page = Number(options.page);
            }
            return api.getServicesTypes(projectId, query);
        },
        [projectId],
    );

    const {
        data,
        fetch,
        updateFilter,
        isLoading
    } = useData<ServicesType>({
        disableInitialLoad: true,
        fetchData: getServicesTypes,
        maintainPages: false,
        initialFilters: [
            { key: 'id', operator: FilterOperator.eq, initialValue: null },
        ],
        initialPagination: {
            page: 1,
            limit: 10,
        },
        initialSort: {
            createdAt: SortOrders.DESC,
        },
    });

    useEffect(() => {
        fetch();
        updateFilter('id', serviceTypeId, FilterOperator.eq)
    }, [updateFilter, fetch]);


    return {
        data,
        isLoading
    }
}
export default usePrintServiceType;
